module.exports = __webpack_public_path__ + "static/img/14000041.d7f542a6.png";